import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import retry from '@segment/utils/retry';
var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat(process.env.NEXT_PUBLIC_SEGMENT_SITE_BACKEND_URL).concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry(get, retryOptions);
  return {
    get: retryGet
  };
};

export { createClient };